import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EventService } from 'src/app/services/event.service';
import { PrivacyDialogComponent } from '../privacy-dialog/privacy-dialog/privacy-dialog.component';
import { TermsDialogComponent } from '../terms-and-conditions/terms-dialog/terms-dialog.component';
import { FvrZeropaySupportPopupService } from '../zeropay-support/fvr-zeropay-support-popup.service';

@Component({
  selector: 'app-partner-faq',
  templateUrl: './partner-faq.component.html',
  styleUrls: ['./partner-faq.component.scss']
})
export class PartnerFaqComponent implements OnInit, OnDestroy {
  constructor(
    private matDialog: MatDialog,
    private supportService: FvrZeropaySupportPopupService,
    private eventService: EventService
  ) {}

  public scrollTo(elementId: string): void {
    (document.querySelector(`#${elementId}`) as Element).scrollIntoView({ behavior: "smooth" });
  }

  ngOnInit(): void {
    this.eventService.howItWorksHide();
    this.eventService.mobileDisplayLogoToolbar.next(true);
  }

  showTerms() {
    this.matDialog.open(TermsDialogComponent, {
      width: '100%',
    });
  }

  showPrivacy() {
    this.matDialog.open(PrivacyDialogComponent, {
      width: '100%',
    });
  }

  showContact() {
    this.supportService.showContactDialog();
  }

  ngOnDestroy(): void {
    this.eventService.howItWorksShow();
  }
}
